module.exports = __webpack_public_path__ + "img/screenshot03.fdac50c7.png";